import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Nav, NavItem, NavLink } from 'reactstrap';
import './AccountManagementComponent.css';
import _ from 'lodash';
import AliasesList from '../aliasesManagement/aliasesList/AliasesList.container';
import ChangePassword from '../changePassword/ChangePassword.container';
import DefaultAliasManagement from '../aliasesManagement/defaultAliasManagement/DefaultAliasManagement.container';
import NotificationSettings from "../notificationSettings/NotificationSettings.container";
import SecuritySettings from "../securitySettings/SecuritySettings.container";
import IconContainer from "../../commonComponents/iconContainer/IconContainer";
import { Utils } from '../../../utils/utils';

const ACCOUNT_PAGES = {
    ALIASES: "aliases",
    EDIT_DEFAULT_ALIAS: "edit_default_alias",
    CHANGE_PASSWORD: "change_password",
    NOTIFICATION_SETTINGS: "notification_settings",
    SECURITY_SETTINGS: "security_settings"
};

class AccountManagementComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentPage: ACCOUNT_PAGES.EDIT_DEFAULT_ALIAS,
            isOpenMenu: false
        };
    }

    render() {
        return (
            <div className="account-management-container">
                {this.renderMenuToggler()}
                <div className={"account-management-navbar" + (this.state.isOpenMenu ? " page-open" : "")}>
                    <h5 className="account-management-label">{_.get(this.props.translation, 'account_management.label')}</h5>
                    <Nav className="account-settings-navbar" vertical pills>
                        {/* //NOTE: disabled in current version */}
                        {/* <NavItem>
                            <NavLink href="#" onClick={this.handleChangePage(ACCOUNT_PAGES.ALIASES)} active={this.state.currentPage === ACCOUNT_PAGES.ALIASES}>
                                {_.get(this.props.translation, ACCOUNT_PAGES.ALIASES + ".label")}
                            </NavLink>
                        </NavItem> */}
                        <NavItem>
                            <NavLink href="#" onClick={this.handleChangePage(ACCOUNT_PAGES.EDIT_DEFAULT_ALIAS)} active={this.state.currentPage === ACCOUNT_PAGES.EDIT_DEFAULT_ALIAS}>
                                {_.get(this.props.translation, "aliases.edit_default_alias")}
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink href="#" onClick={this.handleChangePage(ACCOUNT_PAGES.CHANGE_PASSWORD)} active={this.state.currentPage === ACCOUNT_PAGES.CHANGE_PASSWORD}>
                                {_.get(this.props.translation, ACCOUNT_PAGES.CHANGE_PASSWORD + ".label")}
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink href="#" onClick={this.handleChangePage(ACCOUNT_PAGES.NOTIFICATION_SETTINGS)} active={this.state.currentPage === ACCOUNT_PAGES.NOTIFICATION_SETTINGS}>
                                {_.get(this.props.translation, ACCOUNT_PAGES.NOTIFICATION_SETTINGS + ".label")}
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink href="#" onClick={this.handleChangePage(ACCOUNT_PAGES.SECURITY_SETTINGS)} active={this.state.currentPage === ACCOUNT_PAGES.SECURITY_SETTINGS}>
                                {_.get(this.props.translation, ACCOUNT_PAGES.SECURITY_SETTINGS + ".label")}
                            </NavLink>
                        </NavItem>
                    </Nav>
                </div>
                <div className="account-page-container">
                    {this.renderPageContent()}
                </div>
            </div>
        );
    }

    renderMenuToggler = () => {
        return (
            <div onClick={this.toggleList} className={"toggle-settings-menu-button " + (this.state.isOpenMenu ? "button-open" : "")}>
                <IconContainer className="toggle-settings-menu-icon" icon="arrow_back"/>
                <h6>
                    {Utils.getTagsFromStringWithStyles(
                        _.get(this.props.translation, "account_management." + (this.state.isOpenMenu ? "close_account_management_menu_label" : "open_account_management_menu_label"))
                    )}
                </h6>
            </div>
        );
    };

    renderPageContent = () => {
        switch (this.state.currentPage) {
            case ACCOUNT_PAGES.CHANGE_PASSWORD:
                return <ChangePassword />;
            case ACCOUNT_PAGES.EDIT_DEFAULT_ALIAS:
                return <DefaultAliasManagement />;
            case ACCOUNT_PAGES.ALIASES:
                return <AliasesList />;
            case ACCOUNT_PAGES.NOTIFICATION_SETTINGS:
                return <NotificationSettings/>;
            case ACCOUNT_PAGES.SECURITY_SETTINGS:
                return <SecuritySettings/>;
            default:
                return null;
        }
    };

    handleChangePage = (newPage) => () => {
        this.setState({ currentPage: newPage });
        this.toggleList();
    };

    toggleList = () => {
        this.setState({ isOpenMenu: !this.state.isOpenMenu });
    };
}

AccountManagementComponent.propTypes = {
    translation: PropTypes.object.isRequired
};

export default AccountManagementComponent;



// WEBPACK FOOTER //
// ./src/components/accountManagement/accountManagementComponent/AccountManagementComponent.js